import type {FailedAPIResult} from '@github-ui/copilot-chat-types'

/**
 * `btoa` only accepts Latin1, so any path containing CJK, emoji or accented characters threw
 * `InvalidCharacterError`. Base64 the UTF-8 bytes instead, which is what the server decodes.
 */
export function base64EncodeUtf8(value: string): string {
  let binary = ''
  for (const byte of new TextEncoder().encode(value)) {
    binary += String.fromCharCode(byte)
  }
  return btoa(binary)
}

export function isFailedApiResult(res: Response | FailedAPIResult): res is FailedAPIResult {
  return !res.ok
}
